import { useState } from 'react';
import { useSelector } from 'react-redux';
import { PageHeader, Tabs } from '../components/ui';
import AISettings from '../components/AISettings';

const SEZIONI = [
  { value: 'profilo', label: 'Profilo' },
  { value: 'ai', label: 'Intelligenza artificiale' },
];

export default function SettingsPage() {
  const { user } = useSelector(state => state.auth);
  const [sezione, setSezione] = useState('profilo');

  if (!user) return null;

  const dati = [
    ['Email', user.email],
    ['Nome utente', user.username],
    ['Telefono', user.phone_number || '—'],
    ['Registrato il', new Date(user.created_at).toLocaleDateString('it-IT')],
  ];

  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <PageHeader title="Impostazioni" />
      <Tabs tabs={SEZIONI} value={sezione} onChange={setSezione} label="Sezioni delle impostazioni" />

      {sezione === 'profilo' ? (
        <section className="rounded-lg border border-line bg-surface p-4">
          <dl className="divide-y divide-line">
            {dati.map(([etichetta, valore]) => (
              <div key={etichetta} className="flex items-center justify-between gap-3 py-2.5">
                <dt className="text-sm text-muted">{etichetta}</dt>
                <dd className="text-sm text-ink">{valore}</dd>
              </div>
            ))}
          </dl>
          <p className="mt-3 text-xs text-muted">
            L&apos;accesso avviene con l&apos;email, non con il nome utente.
          </p>
        </section>
      ) : (
        <AISettings />
      )}
    </div>
  );
}
